import { toast } from '@/stores/toast-store';

export function extractErrorMessage(err: any): string {
  const apiMessage = err?.response?.data?.error?.message ?? err?.response?.data?.message;
  const msg = Array.isArray(apiMessage) ? apiMessage.join(', ') : apiMessage;
  return msg || err?.message || '';
}

/**
 * Standardized mutation error handler.
 * Extracts the real backend error message and shows 429-specific rate-limit messaging.
 *
 * Usage:
 *   onError: (err: any) => handleMutationError(err, 'Failed to update loan')
 */
export function handleMutationError(err: any, fallbackMessage: string): void {
  const status = err?.response?.status;
  const msg = extractErrorMessage(err);

  if (status === 429) {
    toast.error('Too many requests — please wait a moment then try again');
  } else if (status === 413) {
    toast.error(`${fallbackMessage}: File too large`);
  } else {
    toast.error(`${fallbackMessage}${msg ? `: ${msg}` : ''}`);
  }
}
